<template>
  <v-app-bar app :flat="true" :height="51" color="#FFF">
    <div class="logo-div">
      <img :src="imgSrc" height="100%"/>
    </div>
  </v-app-bar>
</template>
<style>
  .logo-div{
    border-width: 0px;
    position: absolute;
    left: 25px;
    top: 5px;
    width: 120px;
    height: 40px;
  }
</style>
<script>
  export default {
    name: 'account-head',
    data() {
      return {
        title: this.$vuetify.lang.t('$vuetify.custom.title'),//"易途基础架构",
        imgSrc:require('@/assets/logo.png')
      }
    }
  }
</script>
